import { useQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import env from 'src/env';
import USER_TOKEN from 'src/graphql/queries/authQuery';

const useIsBrandfolderEnabled = () => {
    const [isBrandfolderEnabled, setIsBrandfolderEnabled] = useState<boolean>();
    const [hasBrandfolderAccess, setHasBrandfolderAccess] = useState<boolean>(false);
    const [brandfolderError, setBrandfolderError] = useState<boolean>(false);
    const [isBrandfolderSignUp, setIsBrandfolderSignUp] = useState<boolean>(false);
    const token = localStorage.getItem('id_token');
    const ssoVersion = localStorage.getItem('ssoVersion');
    const { data: profile } = useQuery(USER_TOKEN);
    const brandfolderPath = ssoVersion === '2' ? 'brandfolder-keycloak' : 'brandfolder';

    const brandfolderSignUp = async () => {
        const body = ssoVersion === '2'
            ? { keycloakUserId: profile.token.sub }
            : { email: profile.token.email };

        try {
            const response = await fetch(`${env.ssoV1Url}/api/${brandfolderPath}/signup`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(body),
            });

            const data = await response.json();
            if (data && data.success) {
                setIsBrandfolderSignUp(true);
            }
        } catch (err) {
            console.error(err);
            setBrandfolderError(true);
        }
    };

    const brandfolderStatus = async () => {
        const postData = { accountType: ssoVersion === '2' ? 'keycloak' : 'auth0' };
        try {
            const response = await fetch(`${env.ssoV1Url}/api/${brandfolderPath}/status`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(postData),
            });

            const data = await response.json();
            if (data && data.has_sign_up) {
                setHasBrandfolderAccess(true);
            } else {
                setHasBrandfolderAccess(false);
            }
        } catch (err) {
            console.error(err);
            setBrandfolderError(true);
        }
    };

    useEffect(() => {
        (async () => {
            try {
                const response = await fetch(`${env.ssoV1Url}/api/${brandfolderPath}/isenabled`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        authorization: `Bearer ${token}`,
                    },
                });

                const data = await response.json();
                if (data && data.is_enabled) {
                    setIsBrandfolderEnabled(true);
                    // only check status if brandfodler is available.
                    await brandfolderStatus();
                } else {
                    setIsBrandfolderEnabled(false);
                }
            } catch (err) {
                console.error(err);
                setBrandfolderError(true);
            }
        })();
    // eslint-disable-next-line
    }, [token]);

    return {
        isBrandfolderEnabled,
        brandfolderError,
        brandfolderSignUp,
        brandfolderStatus,
        hasBrandfolderAccess,
        isBrandfolderSignUp,
    };
};

export default useIsBrandfolderEnabled;